module.exports = __webpack_public_path__ + "static/media/25.7a2924e8.svg";